import api from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { FindAuditoriaEmailsDto, AuditoriaEmailDto } from './auditoria-emails.types';

export async function GetAuditoriaEmails(filters: FindAuditoriaEmailsDto) {
  if (filters) {
    filters.skip ??= 0;
    filters.take ??= 10;
  }
  const response = await api.get<[AuditoriaEmailDto[], number]>(Endpoints.AUDITORIA_EMAILS, {
    params: filters,
  });
  return response.data;
}

